import { t } from 'i18next';
import React from 'react';

function ErrorComponent({ showLogoutModal, setShowLogoutModal, errorMessage, onSuccess }) {
    const handleClose = () => {
        setShowLogoutModal(false);
        // If onSuccess callback is provided, call it when user clicks OK
        if (onSuccess) {
            onSuccess();
        }
    };

    return (
        <div>
            {showLogoutModal && (
                <div className="logout_modal_overlay">
                    <div className="logout_modal_content" style={{height: 'auto'}}>
                        <div dangerouslySetInnerHTML={{ __html: errorMessage }} />
                        <div className="logout_modal_buttons">
                            <button onClick={handleClose}>{t('ok') || t('close')}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ErrorComponent;